module.exports = __webpack_public_path__ + "static/media/slideshow-foto-02.e40ef562.png";